import React, { useState } from 'react';
import { cn } from '../../utils/cn';
import FundTab from './components/FundTab';
import ComingSoon from './components/ComingSoon';

const TABS = [
  { key: 'fund', label: 'San pham quy' },
  { key: 'stock', label: 'Co phieu' },
  { key: 'crypto', label: 'Crypto' },
];

export default function TradingPage() {
  const [activeTab, setActiveTab] = useState('fund');

  return (
    <div className="mx-auto max-w-4xl space-y-5">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Giao dich</h1>
        <p className="mt-1 text-sm text-gray-500">Mua ban san pham dau tu</p>
      </div>

      <div className="flex gap-1 rounded-lg bg-gray-100 p-1">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            onClick={() => setActiveTab(tab.key)}
            className={cn(
              'flex-1 rounded-md px-4 py-2 text-sm font-medium transition-colors',
              activeTab === tab.key
                ? 'bg-white text-gray-900 shadow-sm'
                : 'text-gray-500 hover:text-gray-700'
            )}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === 'fund' && <FundTab />}
      {activeTab === 'stock' && <ComingSoon label="Co phieu" />}
      {activeTab === 'crypto' && <ComingSoon label="Crypto" />}
    </div>
  );
}
